// components/common/SubscriptionStatus/styles.js

import styled, { css } from 'styled-components';
import { Button } from '../../../styles/components';
import { SUBSCRIPTION_STATES } from '../../../config/constants';

export const StatusContainer = styled.div`
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    box-shadow: ${props => props.theme.shadows.sm};
    overflow: hidden;
    max-width: 500px;
    margin: ${props => props.theme.spacing['4xl']} auto;
    padding: ${props => props.theme.spacing['2xl']};
    text-align: center;
`;

export const StatusHeader = styled.div`
    padding: ${props => props.theme.spacing.xl};
    margin: -${props => props.theme.spacing['2xl']};
    margin-bottom: ${props => props.theme.spacing.xl};
    background: ${props => {
        if (props.warning) return props.theme.colors.warning.main + '15';
        if (props.alert) return props.theme.colors.error.main + '15';
        return props.theme.colors.background.alt;
    }};
    
    h3 {
        color: ${props => props.theme.colors.text.primary};
        font-size: ${props => props.theme.typography.sizes.xl};
        font-weight: ${props => props.theme.typography.weights.semibold};
    }
`;

export const StatusContent = styled.div`
    padding: ${props => props.theme.spacing.xl} 0;

    p {
        margin-bottom: ${props => props.theme.spacing.lg};
        font-size: ${props => props.theme.typography.sizes.lg};
        color: ${props => props.theme.colors.text.primary};
        
        &.info {
            color: ${props => props.theme.colors.text.secondary};
            font-size: ${props => props.theme.typography.sizes.md};
        }
    }
`;

export const ActionButton = styled(Button)`
    margin-top: ${props => props.theme.spacing.xl};
    padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.xl};
    min-width: 200px;
    font-size: ${props => props.theme.typography.sizes.md};
`;

export const StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: ${props => `${props.theme.spacing.xs} ${props.theme.spacing.sm}`};
    border-radius: ${props => props.theme.borderRadius.full};
    font-size: ${props => props.theme.typography.sizes.sm};
    font-weight: ${props => props.theme.typography.weights.medium};
    
    ${props => {
        switch (props.status) {
            case SUBSCRIPTION_STATES.PENDING_ADMIN:
                return css`
                    background: ${props.theme.colors.warning.main}15;
                    color: ${props.theme.colors.warning.main};
                `;
            case SUBSCRIPTION_STATES.PENDING_PAYMENT:
                return css`
                    background: ${props.theme.colors.error.main}15;
                    color: ${props.theme.colors.error.main};
                `;
            case SUBSCRIPTION_STATES.PAYMENT_SUBMITTED:
                return css`
                    background: ${props.theme.colors.warning.main}15;
                    color: ${props.theme.colors.warning.main};
                `;
            case SUBSCRIPTION_STATES.ACTIVE:
                return css`
                    background: ${props.theme.colors.success.main}15;
                    color: ${props.theme.colors.success.main};
                `;
            default:
                return css`
                    background: ${props.theme.colors.text.disabled}15;
                    color: ${props.theme.colors.text.disabled};
                `;
        }
    }}
`;